export default __webpack_public_path__ + "static/media/bbq-rib-dish.ccd09c72.jpg";